import Tdg_CompanyListModelBase from '../_generated/modelBases/tdg-company-list-model-base';

export default class Tdg_CompanyListModel extends Tdg_CompanyListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
